import { useMutation } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { AdminNotificationResult, SendNotificationInput } from "./notification-types";

/**
 * Fires an ad-hoc notification to one user via
 * `POST /api/admin/notifications`. The endpoint returns 200 for every
 * non-error outcome — including the `SKIPPED_*` / `FAILED` variants —
 * so the result is surfaced through `onSuccess`, not `onError`. Only
 * 4xx/5xx (validation, permission, rate-limit, server) reach `onError`.
 *
 * No query invalidation: a send has no effect on any cached entity
 * (preferences/devices aren't mutated by sending).
 */
async function sendNotification(input: SendNotificationInput): Promise<AdminNotificationResult> {
  return httpClient<AdminNotificationResult>("/api/admin/notifications", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useSendNotification() {
  return useMutation({ mutationFn: sendNotification });
}
